import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { OnePasswordAccesses } from "./accesses.ts";
import { OnePasswordComponents } from "./components.ts";

// Rule filter values compile to regular expressions, so a rule can say, e.g.,
// that any Login item in a vault needs approval.
const OnePasswordFilters = {
  account: { keys: ["name"] },
  vault: { keys: ["name", "id"] },
  item: { keys: ["title", "id"] },
  itemType: { keys: ["name"] },
} as const satisfies AnyFilterSchema;
export type OnePasswordFilters = typeof OnePasswordFilters;

// Keyed by component, so a new component doesn't compile until it has one.
// The new item's form labels an item's id with its component's kind, then
// this: "Connector ID", "Account sign-in address".
const IDENTIFIERS: Record<keyof typeof OnePasswordComponents, string> = {
  connector: "ID",
  account: "sign-in address",
};
// `Registration` hands `identifier` any string, not just a component key.
const identifiers: Partial<Record<string, string>> = IDENTIFIERS;

export const OnePasswordRegistration = Registration({
  accesses: OnePasswordAccesses,
  category: "resource",
  components: OnePasswordComponents,
  docs: { install: "1password", request: "1password/requesting-access" },
  filters: OnePasswordFilters,
  identifier: (component) => identifiers[component] ?? component,
  // Each component is named for what one of its items is.
  itemKind: (component) => component,
  label: "1Password",
  logoUrl: "https://1password.com/favicon.ico",
  maturity: "beta",
  requestType: "requestable",
  useMapping: [{ component: "account", use: "iam_write" }],
});

// The key starts with a digit, so TypeScript maps quote it.
registerIntegration("1password", OnePasswordRegistration);
